import axios from "axios";
import { API_BASE_URL } from "./constants";

const options = {
  headers: {
    "Content-Type": "application/json"
  }
};

export const getFormStatus = formNumber => {
  return axios.get(API_BASE_URL + `/form/${formNumber}`, options);
};

export const getNextFormNumberInGroup = formNumbGroup => {
  return axios.get(
    API_BASE_URL + `/form/getNextFormNumberInGroup-${formNumbGroup.slice(-2)}`,
    options
  );
};

export const submitForm = formRequest => {
  return axios.post(API_BASE_URL + "/form/submit-form", formRequest, options);
};

export const approveForm = (formId, approvalRequest) => {
  return axios.post(
    API_BASE_URL + `/form/approve-form-${formId}`,
    approvalRequest,
    options
  );
};
